"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCommonRequestHeaders = void 0;
const uuid_1 = require("uuid");
const AppSettings_1 = __importDefault(require("../AppSettings"));
const helpers_1 = require("./helpers");
const getCommonRequestHeaders = () => {
    const headers = {
        /**
         * A random ID string which allows us to trace the request through our
         * whole system.
         */
        AccurxCorrelationId: (0, uuid_1.v4)(),
        /**
         * This header was added by our previous HTTP Client so let's keep it
         * but make sure to check why it's useful and come back to add comments.
         */
        Iframe: (0, helpers_1.isInIframe)() ? "true" : "false",
    };
    /**
     * The CSRF token allows our server to verify the request came from our app.
     */
    const csrfToken = (0, helpers_1.getCookie)("CSRF-TOKEN");
    if (csrfToken) {
        headers["X-CSRF-TOKEN"] = csrfToken;
    }
    /**
     * Make sure API calls to go to the correct app version when on a branch
     * deploy.
     */
    if (AppSettings_1.default.accurxPrNumber) {
        headers["AccurxPrNumber"] = AppSettings_1.default.accurxPrNumber;
    }
    /**
     * Add some generally useful information about the client
     */
    const apiClientName = AppSettings_1.default.getWebClientAppName();
    const apiClientVersion = AppSettings_1.default.getWebClientAppVersion();
    if (apiClientName && apiClientVersion) {
        headers["app-name"] = apiClientName;
        headers["app-version"] = apiClientVersion;
    }
    return headers;
};
exports.getCommonRequestHeaders = getCommonRequestHeaders;
//# sourceMappingURL=getCommonRequestHeaders.js.map